/*
Copyright (C) 2016-2024 Stichting Palga
This file is distributed under the GNU Affero General Public License
(see accompanying file LICENSE).
*/
export const environment = {
	production: false,
	apiUrl: 'https://acc.palga-cpx.nl/api',
};
